import { useLocation } from 'react-router-dom';

export const useQuery = (): URLSearchParams | undefined => {
  const search = useLocation().search;

  if (!search?.length) {
    return;
  }

  return new URLSearchParams(search);
};
